import * as React from "react";
import { useState, useEffect, useLayoutEffect, useRef } from "react";
import { debounce } from "lodash";
import { createI18n } from "../../../modules/metajson-sub/src/libs/controls/components/I18n";
import { cn, createCounterMessage, trimString } from "../../../modules/metajson-sub/src/libs/helpers/Utils";
import { TextBoxValidate } from "../../../modules/metajson-sub/src/core/validation/validate";
import { addValue } from "../../../actions";
import { useDispatch } from "react-redux";
import { tr } from "../../../components/Utils";
import ErrorAlert from "../../../modules/metajson-sub/src/libs/controls/components/ErrorAlert";

const Help = ({ onClick }) => (
	<span onClick={onClick} className="input-group-addon btn btn-default">
		<span className="glyphicon glyphicon-question-sign" />
	</span>
);

const Notification = ({ onClick }) => (
	<span onClick={onClick} className="input-group-addon btn btn-default">
		<span className="glyphicon glyphicon-info-sign" />
	</span>
);

const AutocompleteTextboxField = ({
    schema,
    api,
    error,
    visited,
    dispatcher,
    opts,
    information,
    values,
    rowIndex,
}) => {

    const { extra, maxLength, minLength = 0, type, label, notification, description, required, contentNumb, id, title } = schema;

    const [isOpenNotification, setIsOpenNotification] = useState(true);
    const [isOpenInfo, setIsOpenInfo] = useState(false);
    const [suggestList, setSuggestList] = useState(null);
    const [valueState, setValueState] = useState(null);
    const [isValueSet, setIsValueSet] = useState(false);

    const ref = useRef(null);
    
    const dispatch = useDispatch();

    const handlerClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setSuggestList(null);
        }
    };

    useEffect(() => {
        if (isValueSet) {
            document.addEventListener('click', handlerClickOutside, true);
        }
  
        return () => {
          document.removeEventListener('click', handlerClickOutside, true);
        };
    }, [schema.value])

    useLayoutEffect(() => {
        if (schema.value) {
            setValueState(schema.value)
        }
    }, []);

    const i18nControls = extra?.i18nControls;

    const openNotification = () => {
		setIsOpenNotification(!isOpenNotification);
	}

	const handlerChangeValue = (checkedData) => () => {
        setValueState(checkedData);
		emitBlurDebounced(checkedData);
		setSuggestList(null);
	};

	const getSuggest = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		event.persist();
		setValueState(trimString(100, event.target.value));
		emitSuggestDebounced();
	};

    const emitBlur = (value) => {
        setIsValueSet(true);
        dispatch(addValue(schema.id, value, false));
    }

	// TODO: Dadata - в большинстве реализаций через GET
	const emitSuggest = () => {
		const _method = "post";
		const _url = schema?.data?.url;
		const token = "f12a0190120625ee00ebb2dd68cb4db2767caf70";

		api.moduleApi[_method](
			// TODO: когда везде будет дадата гет запросом - убрать лишние проверки
			_url,
			{
				query: valueState,
			},
			{
				success: (response) => {
					if (response) {
						setSuggestList(response.data.suggestions);
					}
				},
				error: (_error) => {
					setSuggestList(null);
				},
			},
            token
		);
	};

    const emitBlurDebounced = debounce(emitBlur, 200);

    const emitSuggestDebounced = debounce(emitSuggest, 200);

    const onBlur = () => {
        emitBlurDebounced(valueState);
    }

    const onClick = () => {
		setIsOpenInfo(!isOpenInfo);
	}

    return (
        <div id={id} className="form-group">
            <div className="col-xs-12 fullwidth">
                <label className="control-label">
                    {contentNumb && <div className="reportbox-content-num">{contentNumb}</div>}
                        <div className={cn("reportbox-content-desc", { required })}>
                            <span className={id}>
                                {title.ru}
                            </span>
                        </div>
                </label>
            </div>
            <div className="col-xs-12">
                <div className="input-group" ref={ref} style={{ width: "100%" }}>
                    <div className={`${ valueState ? "has-success" : "" }`} style={{ width: "100%" }}>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={schema?.extra?.placeholder?.ru ?? schema?.placeholder ?? ""}
                            onChange={getSuggest}
                            onBlur={onBlur}
                            value={valueState || ""}
                            title={valueState}
                            disabled={schema.disabled}
                        />

                        {suggestList && (
                            <>
                                <div className="list-group">
                                    {suggestList.map((item, index) => (
                                        <button
                                            type="button"
                                            key={index}
                                            className="list-group-item list-group-item-action"
                                            onClick={handlerChangeValue(item.value)}
                                        >
                                            <p>{item.value}</p>
                                        </button>
                                    ))}
                                </div>
                            </>
                        )}

                        {maxLength && (maxLength > 0 || minLength > 0) && i18nControls && (
                            <div className="input-counter">{createCounterMessage(valueState, maxLength, minLength)}</div>
                        )}

                        {/* {notification && isOpenNotification && (
                            <div
                                className="alert alert-warning"
                                role="alert"
                                dangerouslySetInnerHTML={{ __html: tr(notification) }}
                            />
                        )} */}
                        {description && isOpenInfo && (
                            <div
                                className="alert alert-warning"
                                role="alert"
                                dangerouslySetInnerHTML={{ __html: tr(description) }}
                            />
                        )}
                        {/* <ErrorAlert errorMessage={errorText} /> */}
                    </div>
                    {i18nControls ? createI18n(i18nControls, api, dispatcher, {}, visited, type, onClick, openNotification) : null}
                    {label && <span className="input-group-addon">{label}</span>}
                    {/* {!i18nControls && isOpenNotification && <Notification onClick={openNotification} />} */}
                    {/* {!i18nControls && onClick && <Help onClick={onClick} />} */}
                </div>
                {maxLength && (maxLength > 0 || minLength > 0) && !i18nControls && (
                    <div className="input-counter">{createCounterMessage(valueState, maxLength, minLength)}</div>
                )}
            </div>
        </div>
    );
}

export function createAutocompleteTextboxField(
    schema: any,
    // TODO: abstract type any
    api: any,
    dispatcher: any,

    error: any,
    visited: boolean,
    // TODO: abstract type any
    opts: any,
    // TODO: abstract type any
    information: any,
    values: Array<{ controlid: string; value: unknown }>,
    rowIndex: number
): React.ReactElement<any> {
    return (
        <AutocompleteTextboxField
            schema={schema}
            api={api}
            error={error}
            visited={visited}
            dispatcher={dispatcher}
            opts={opts}
            information={information}
            values={values}
            rowIndex={rowIndex}
        />
    );
}
